import get from 'lodash/get'

export const getSeoProps = data => {
  const title = get(data, 'seotitle[0].text')
  const description = get(data, 'seodescription[0].text')

  return { title, description }
}
